export default __webpack_public_path__ + "static/media/Loader.33c42a61.gif";